import React from 'react';
import myLogo from '../images/HDSBCPartnershipLogos_HDDistributing.png';

function Footer() {
    return (
          <div className="mt-3">
              <div><img src={myLogo} alt="partner-logo" className="bottom_logo"></img></div>
              <div className="footer-style"><b>HD DISTRIBUTING | MINNEAPOLIS, MN | HD2PRO.COM | 877-307-6689</b></div>
          </div>
    );
}

export default Footer;
